class SliderComponent extends HTMLElement {
  constructor() {
    super()
    $(document).ready(() => {
      this.initialize();
    });
  }

  setItemSize() {
    this.containerSize = this.querySelector('.slider-container').getBoundingClientRect();
    this.itemSize = this.querySelector('.slider-item').getBoundingClientRect();
    this.size = Math.floor(this.containerSize.width / this.itemSize.width)
  }

  initialize() {
    this.index = 0;
    this.container = this.querySelector('.slider-container');
    if(!this.container) return;
    this.items = this.querySelectorAll('.slider-item');
    this.next = this.querySelector('.slider-next');
    this.previous = this.querySelector('.slider-previous');
    this.setItemSize();
    
    this.next.addEventListener('click', () => {
      this.setItemSize();
      if(this.index  < (this.items.length - this.size)) {
        gsap.to(this.container, {
          x: -1 * (this.index + 1) * this.itemSize.width,
          duration: 0.8,
          ease: 'expo.inOut'
        })
        this.index += 1;
      }
      this.setHiddenClasses();
    })

    this.previous.addEventListener('click', () => {
      this.setItemSize();
      if(this.index > 0) {
        gsap.to(this.container, {
          x: -1 * (this.index - 1) * this.itemSize.width,
          duration: 0.8,
          ease: 'expo.inOut'
        })
        this.index -= 1;
      }
      this.setHiddenClasses();
    })

    window.addEventListener('resize', () => {
      this.setItemSize();
      this.container.style.transform = `translateX(-${this.index * this.itemSize.width}px)`
    })
  }

  setHiddenClasses() {
    if(this.index > 0) {
      this.previous.classList.remove('inactive')
    } else {
      this.previous.classList.add('inactive')
    }
    if(this.index < this.items.length - this.size) {
      this.next.classList.remove('inactive')
    } else {
      this.next.classList.add('inactive')
    }
  }
}

customElements.define('slider-component', SliderComponent);